import { link } from 'framer-motion/client';
import React, { useState, useEffect } from 'react';

const CookieConsent = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem('cookieAccepted');
    if (!consent) {
      setIsVisible(true);
    }
  }, []);

  const acceptCookies = () => {
    localStorage.setItem('cookieAccepted', 'true');
    setIsVisible(false);
  };

  if (!isVisible) return null;

  return (
    <div style={styles.banner}>
      {/* <p style={{ margin: 0 }}>
       We use cookies—not the kind you dunk in milk, but the ones that make our site work better. By hanging out here, you're cool with that!
      </p> */}

      <p style={{ margin: 0 }}>
        We use{' '}
        <a
          href="https://www.allaboutcookies.org/"
          target="_blank"
          rel="noopener noreferrer"
          style={styles.link}
        >
          cookies
        </a>{' '}
        🍪— not the kind you dunk in milk, but the ones that make our site work better. By hanging out here, you’re cool with that!
      </p>

      <button style={styles.button} onClick={acceptCookies}>Sounds good!</button>
    </div>
  );
};

const styles = {
  banner: {
    position: 'fixed',
    bottom: 0,
    width: '100%',
    background: '#4F6F52', // earthy green
    color: '#fff',
    padding: '1em',
    textAlign: 'center',
    zIndex: 1000,
    fontSize: '0.9em',
    boxShadow: '0 -2px 10px rgba(0,0,0,0.1)',
    display: 'flex',
    flexWrap: 'wrap',           // allow wrapping on small screens
    justifyContent: 'center',
    alignItems: 'center',
    boxSizing: 'border-box',    // include padding in width
  },
  button: {
    background: '#EDE9D5', // light beige
    color: '#4F6F52',
    border: 'none',
    padding: '0.5em 1em',
    marginLeft: '1em',
    borderRadius: 5,
    cursor: 'pointer',
    fontWeight: 'bold',
    flexShrink: 0,              // prevent button from shrinking too much
  },
  link: {
    color: '#EDE9D5', // light beige
    textDecoration: 'underline',
  },
};

export default CookieConsent;
